var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-credit-card-payment",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes zoomIn{0%{opacity:0;transform:scale(.5)}to{opacity:1;transform:scale(1)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes lightSpeedLeft{60%{transform:skewX(-10deg);opacity:1}80%{transform:skewX(2deg)}}svg#freepik_stories-credit-card-payment:not(.animated) .animable{opacity:0}")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-25",
    style: {
      transformOrigin: "251.85px 327.38px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-25",
    cx: 251.85,
    cy: 327.38,
    rx: 220.66,
    ry: 120.67,
    style: {
      fill: "#f5f5f5",
      transformOrigin: "251.85px 327.38px 0"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-25",
    style: {
      transformOrigin: "105.49px 359.87px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-25",
    cx: 105.49,
    cy: 359.87,
    rx: 46.77,
    ry: 27,
    style: {
      fill: "#e0e0e0",
      transformOrigin: "105.49px 359.87px 0"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-25",
    style: {
      transformOrigin: "255.81px 223.877px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-25",
    style: {
      transformOrigin: "255.81px 223.877px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.13 127.6c4-2.11 9.43-1.7 15.41 1.76a37.34 37.34 0 0 1 7.8 6.14c8.45 8.52 14.45 21.39 14.45 32.41 0 14.21 10 31.47 22.27 38.58l22.27 12.85 94.91-54.78L203 151.7c-12.29-7.09-22.27-24.37-22.27-38.57s-10-31.46-22.27-38.56c-6-3.49-11.54-3.86-15.55-1.66l-.54.3-31.31 18.09-5 2.85z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "136.685px 145.439px 0"
    },
    id: "elcboekyfva4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.47 204a.67.67 0 0 0-.74 0l-2.73 1.59a2.28 2.28 0 0 0-1 1.77v32.07l115 65.25 4.53-34.29z",
    style: {
      fill: "#263238",
      transformOrigin: "384.765px 254.284px 0"
    },
    id: "elx68biw9jhuo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.48 270.35a.75.75 0 0 0-.69.1L441 272a1.93 1.93 0 0 0-.72.75l-115.03-66.41a2.16 2.16 0 0 1 .72-.75l2.75-1.58a.67.67 0 0 1 .74 0z",
    style: {
      fill: "#455a64",
      transformOrigin: "384.865px 238.324px 0"
    },
    id: "elt1owpqykfu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.79 270.44 441 272a2.26 2.26 0 0 0-1 1.77v30.88l4.8 2.74V271c.01-.62-.45-.88-1.01-.56z",
    style: {
      fill: "#37474f",
      transformOrigin: "442.4px 288.846px 0"
    },
    id: "elln0ofh8uqy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "els3jvjfo0ej",
    style: {
      transformOrigin: "378.885px 274.71px 0"
    },
    className: "animable",
    d: "M440.01 304.68v2.11l-7.19 3.2-115.06-66.44 7.19-4.12 115.06 65.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m435.22 314.15 8.57-5a2.25 2.25 0 0 0 1-1.77l-4.8-2.74a2.24 2.24 0 0 1-1 1.77l-2.75 1.59c-.56.32-1 .06-1-.59z",
    style: {
      fill: "#37474f",
      transformOrigin: "440.005px 309.395px 0"
    },
    id: "elnif8p9wr94f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cards--inject-25",
    style: {
      transformOrigin: "393.204px 217.125px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.69 310.81a4.15 4.15 0 0 0 1.8-3.26V203.78a4.24 4.24 0 0 0-1.92-3.33l-133.12-76.86a3.61 3.61 0 0 0-5.53 3.19v103.77a4.25 4.25 0 0 0 1.93 3.33L458 310.74a4.14 4.14 0 0 0 3.69.07z",
    style: {
      fill: "#f04e30",
      transformOrigin: "393.204px 217.123px 0"
    },
    id: "eljtmd9gwfxtn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.89 205.86v103.77c0 1.22-.86 1.72-1.92 1.11l-133.12-76.86a4.25 4.25 0 0 1-1.93-3.33V126.78c0-1.22.87-1.72 1.93-1.11L458 202.53a4.24 4.24 0 0 1 1.89 3.33z",
    style: {
      fill: "#f04e30",
      transformOrigin: "391.405px 218.205px 0"
    },
    id: "elku3sk1wltkf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.49 203.78v103.77a4.15 4.15 0 0 1-1.8 3.26 4.08 4.08 0 0 1-3.31.11c.86.28 1.51-.22 1.51-1.29V205.85a4 4 0 0 0-.56-1.89l3.59-2.08a3.91 3.91 0 0 1 .57 1.9z",
    style: {
      opacity: 0.2,
      transformOrigin: "460.935px 256.549px 0"
    },
    className: "animable",
    id: "elb5rc2ikd5rn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.07 232.91v16.37c0 1.23-.86 1.72-1.92 1.11L425.76 238a4.24 4.24 0 0 1-1.92-3.32v-16.34c0-1.22.86-1.72 1.92-1.11l21.39 12.35a4.24 4.24 0 0 1 1.92 3.33z",
    style: {
      fill: "#455a64",
      transformOrigin: "436.455px 233.811px 0"
    },
    id: "elbu4q33r74dd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-25)",
      transformOrigin: "436.455px 233.83px 0"
    },
    id: "el221fcbqgb35",
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "436.455px 229.65px 0",
      transform: "rotate(-59.98deg)"
    },
    className: "animable",
    d: "M436.02 210.92h.87v37.46h-.87z",
    id: "elq5858shpo6i"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "441.865px 236.94px 0"
    },
    id: "el51kmu5xyh3x",
    className: "animable",
    d: "M441.43 232.77h.87v8.34h-.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "431.055px 230.725px 0"
    },
    id: "elhvhsqfy9er",
    className: "animable",
    d: "M430.62 226.56h.87v8.33h-.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      transformOrigin: "436.455px 238.01px 0",
      transform: "rotate(-59.98deg)"
    },
    className: "animable",
    d: "M436.02 219.28h.87v37.46h-.87z",
    id: "el7tzmg2vi7tq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.07 264.13V268c0 1.23-.86 1.72-1.92 1.11l-21.39-12.35a4.24 4.24 0 0 1-1.92-3.32v-3.89c0-1.23.86-1.72 1.92-1.11l21.39 12.35a4.24 4.24 0 0 1 1.92 3.34z",
    style: {
      fill: "#fafafa",
      transformOrigin: "436.455px 258.775px 0"
    },
    id: "el4185svuaklr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 246.78v3.89c0 1.22-.86 1.72-1.92 1.11l-21.39-12.35a4.24 4.24 0 0 1-1.92-3.33v-3.88c0-1.23.86-1.73 1.92-1.11l21.39 12.35a4.24 4.24 0 0 1 1.92 3.32z",
    style: {
      fill: "#fafafa",
      transformOrigin: "406.385px 241.442px 0"
    },
    id: "elatag1vt3txw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 229.44v3.89c0 1.22-.86 1.72-1.92 1.11l-21.39-12.35a4.24 4.24 0 0 1-1.92-3.33v-3.89c0-1.22.86-1.72 1.92-1.11l21.39 12.35a4.26 4.26 0 0 1 1.92 3.33z",
    style: {
      fill: "#fafafa",
      transformOrigin: "376.385px 224.1px 0"
    },
    id: "eljj6wzgp0mxj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 212.1v3.9c0 1.23-.86 1.73-1.92 1.11l-21.39-12.34a4.27 4.27 0 0 1-1.92-3.33v-3.89c0-1.22.86-1.72 1.92-1.11l21.39 12.35a4.24 4.24 0 0 1 1.92 3.31z",
    style: {
      fill: "#fafafa",
      transformOrigin: "346.385px 206.778px 0"
    },
    id: "elbk0puilzkjd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.7 216.79 4.91 2.83a2.57 2.57 0 0 1 1.15 2v1.5c0 .73-.52 1-1.15.66L345.7 221a2.56 2.56 0 0 1-1.15-2v-1.5c0-.78.52-1.08 1.15-.71z",
    style: {
      opacity: 0.15,
      transformOrigin: "348.155px 220.279px 0"
    },
    className: "animable",
    id: "el9iwzserefo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.89 210.55 4.9 2.83a2.55 2.55 0 0 1 1.16 2v1.5c0 .74-.52 1-1.16.67l-4.9-2.83a2.54 2.54 0 0 1-1.15-2v-1.5c0-.74.51-1.04 1.15-.67z",
    style: {
      opacity: 0.15,
      transformOrigin: "337.345px 214.041px 0"
    },
    className: "animable",
    id: "elrimlu44bs4k"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.79 256.69-61-35.24c-1.06-.61-1.92-.12-1.92 1.11v1.8a4.24 4.24 0 0 0 1.92 3.33l61 35.24c1.06.61 1.92.12 1.92-1.11V260a4.24 4.24 0 0 0-1.92-3.31z",
    style: {
      opacity: 0.15,
      transformOrigin: "366.29px 242.19px 0"
    },
    className: "animable",
    id: "elb4gzar84fmb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.41 155.05a11.16 11.16 0 0 1-1.26-5.38c0-2 .41-3.34 1.23-3.94s2-.44 3.54.44a10.32 10.32 0 0 1 1.75 1.27 8 8 0 0 1 1.33 1.5.64.64 0 0 1 .13.36.38.38 0 0 1-.08.25l-.46.81c-.06.09-.12.12-.18.08a.8.8 0 0 1-.23-.23 6.62 6.62 0 0 0-2-1.79c-.91-.52-1.62-.58-2.12-.17s-.75 1.3-.75 2.68a7.64 7.64 0 0 0 .78 3.57 5.52 5.52 0 0 0 2.15 2.28 3.23 3.23 0 0 0 2.09.57.4.4 0 0 1 .23 0q.09 0 .18.3l.52 1.48a.93.93 0 0 1 .05.24c0 .07-.05.13-.16.17-.69.26-1.75 0-3.19-.85a9.24 9.24 0 0 1-3.55-3.64z",
    style: {
      fill: "#fff",
      transformOrigin: "338.229px 152.504px 0"
    },
    id: "eliovr4baw5zi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.52 160.89a1.3 1.3 0 0 1-.14-.65v-10.46c0-.25 0-.42.14-.5s.24-.05.45.07l3.35 1.93a6.36 6.36 0 0 1 3.35 5.86 3.7 3.7 0 0 1-.39 1.89 1.31 1.31 0 0 1-1.18.65l1.39 4.86a.93.93 0 0 1 0 .27c0 .21-.09.26-.28.15l-1.47-.84a1.06 1.06 0 0 1-.27-.22.85.85 0 0 1-.16-.37l-1.18-4.53-1.57-.91v3.46a.67.67 0 0 1-.13.49c-.09.08-.25 0-.47-.08l-1-.57a1.08 1.08 0 0 1-.44-.5zm3.48-4.11c.5.29.88.36 1.13.23s.38-.52.38-1.13a3.09 3.09 0 0 0-.35-1.53 2.59 2.59 0 0 0-1-1l-1.57-.91v3.52z",
    style: {
      fill: "#fff",
      transformOrigin: "347.028px 157.126px 0"
    },
    id: "elsuvnqm2w3fb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.9 165.73a1.3 1.3 0 0 1-.14-.65v-10.46c0-.26 0-.42.14-.5s.24-.05.45.07l5.49 3.17a1.05 1.05 0 0 1 .44.42 1.43 1.43 0 0 1 .12.64v.65a.77.77 0 0 1-.12.52c-.08.07-.23 0-.44-.08l-3.9-2.25V160l2.72 1.58a1 1 0 0 1 .44.41 1.48 1.48 0 0 1 .12.65v.61a.77.77 0 0 1-.12.52c-.08.07-.22 0-.44-.08l-2.72-1.57V165l3.89 2.25a1 1 0 0 1 .43.42 1.51 1.51 0 0 1 .12.65v.64c0 .27 0 .44-.12.5s-.22 0-.43-.08l-5.48-3.16a1.08 1.08 0 0 1-.45-.49z",
    style: {
      fill: "#fff",
      transformOrigin: "355.082px 161.78px 0"
    },
    id: "el181omv3tx3q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.49 170.11a1.3 1.3 0 0 1-.14-.65V159c0-.25 0-.42.14-.5s.24-.05.45.07l2.78 1.61a8.93 8.93 0 0 1 3.44 3.43 10.69 10.69 0 0 1 1.17 5.22c0 2-.39 3.33-1.19 3.85s-1.93.34-3.42-.52l-2.78-1.6a1.08 1.08 0 0 1-.45-.45zm3.33 0c.79.45 1.37.5 1.76.14s.58-1.24.58-2.65a7.68 7.68 0 0 0-.58-3.31 4.26 4.26 0 0 0-1.76-1.88l-1.29-.75v7.7z",
    style: {
      fill: "#fff",
      transformOrigin: "363.342px 165.713px 0"
    },
    id: "el9sroyda1x7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.56 175.35a1.34 1.34 0 0 1-.14-.66v-10.45c0-.26 0-.42.14-.5s.24-.05.45.07l1 .57a1.2 1.2 0 0 1 .47.45 1.63 1.63 0 0 1 .13.67V176a.7.7 0 0 1-.13.5c-.09.07-.25.05-.47-.08l-1-.57a1.14 1.14 0 0 1-.45-.5z",
    style: {
      fill: "#fff",
      transformOrigin: "369.517px 170.118px 0"
    },
    id: "elg4dol6u2w9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.28 178.65a1.39 1.39 0 0 1-.14-.65v-9.08l-2.14-1.25a1 1 0 0 1-.43-.42 1.43 1.43 0 0 1-.12-.64V166a.77.77 0 0 1 .12-.52c.08-.07.22 0 .43.08l6.53 3.77a1.17 1.17 0 0 1 .45.43 1.56 1.56 0 0 1 .12.66v.58c0 .26 0 .42-.12.49s-.24 0-.45-.08l-2.17-1.25v9.08c0 .26 0 .42-.13.49s-.25 0-.47-.09l-1-.56a1.16 1.16 0 0 1-.48-.43z",
    style: {
      fill: "#fff",
      transformOrigin: "375.272px 172.605px 0"
    },
    id: "els59wv4reh1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.65 184.05a11.15 11.15 0 0 1-1.26-5.37c0-2 .41-3.35 1.23-3.94s2-.45 3.54.44a10.27 10.27 0 0 1 1.75 1.26 8.73 8.73 0 0 1 1.33 1.5.66.66 0 0 1 .13.36.36.36 0 0 1-.08.25l-.46.81c-.06.1-.12.13-.19.09a1.09 1.09 0 0 1-.22-.24 6.64 6.64 0 0 0-2-1.78c-.9-.53-1.61-.58-2.11-.17s-.76 1.3-.76 2.67a7.66 7.66 0 0 0 .79 3.58 5.64 5.64 0 0 0 2.15 2.28 3.34 3.34 0 0 0 2.09.57.3.3 0 0 1 .22 0 .64.64 0 0 1 .19.3l.51 1.48a.69.69 0 0 1 .06.24c0 .07-.06.13-.16.18-.69.26-1.75 0-3.19-.86a9.18 9.18 0 0 1-3.56-3.65z",
    style: {
      fill: "#fff",
      transformOrigin: "388.474px 181.52px 0"
    },
    id: "elm8repqbizum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393 189.36a1.18 1.18 0 0 1 0-.25l3.43-8.9c.06-.17.13-.27.2-.3a.41.41 0 0 1 .33.07l1 .56a.85.85 0 0 1 .32.3 2.28 2.28 0 0 1 .2.53l3.42 12.85a1.25 1.25 0 0 1 0 .31c0 .2-.08.25-.24.16l-1.6-.93a.9.9 0 0 1-.27-.23 1.15 1.15 0 0 1-.15-.38l-.61-2.43-3.21-1.86-.6 1.74c0 .12-.09.18-.15.2a.36.36 0 0 1-.27-.07l-1.6-.93a.46.46 0 0 1-.2-.44zm5.57-1L397.5 184l-1.11 3.17z",
    style: {
      fill: "#fff",
      transformOrigin: "397.452px 187.317px 0"
    },
    id: "el6ow1wh1d7lb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.21 195.35a1.28 1.28 0 0 1-.14-.65v-10.45c0-.26 0-.43.14-.5s.24-.06.45.07l3.35 1.93a6.32 6.32 0 0 1 3.36 5.85 3.69 3.69 0 0 1-.4 1.89 1.31 1.31 0 0 1-1.18.65l1.39 4.86a.93.93 0 0 1 0 .27c0 .21-.09.26-.28.16l-1.47-.85a.89.89 0 0 1-.27-.22 1 1 0 0 1-.16-.36l-1.22-4.58-1.57-.91V196a.71.71 0 0 1-.13.5c-.09.07-.25 0-.47-.09l-1-.57a1.08 1.08 0 0 1-.4-.49zm3.48-4.11c.5.29.88.37 1.13.23s.38-.51.38-1.12a3.1 3.1 0 0 0-.35-1.54 2.59 2.59 0 0 0-1-1l-1.57-.91v3.53z",
    style: {
      fill: "#fff",
      transformOrigin: "406.722px 191.593px 0"
    },
    id: "elpnxv1gwiap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.59 200.19a1.39 1.39 0 0 1-.14-.65v-10.45a.69.69 0 0 1 .14-.51c.09-.07.24-.05.45.07l2.78 1.61a8.93 8.93 0 0 1 3.44 3.43 10.69 10.69 0 0 1 1.17 5.22c0 2.05-.39 3.33-1.19 3.85s-1.93.34-3.42-.52l-2.78-1.6a1.08 1.08 0 0 1-.45-.45zm3.34 0c.78.45 1.37.5 1.75.14s.59-1.24.59-2.65a7.66 7.66 0 0 0-.59-3.31 4.24 4.24 0 0 0-1.75-1.88l-1.3-.75v7.7z",
    style: {
      fill: "#fff",
      transformOrigin: "415.44px 195.795px 0"
    },
    id: "elyh0bhpj3xs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.92 201.88-3.59 2.12a4 4 0 0 0-1.36-1.43l-133.13-76.9c-1-.55-1.76-.19-1.9.8a3.59 3.59 0 0 1 5.51-2.88l133.12 76.86a3.81 3.81 0 0 1 1.35 1.43z",
    style: {
      fill: "#fafafa",
      opacity: 0.5,
      transformOrigin: "392.93px 163.516px 0"
    },
    className: "animable",
    id: "elq0cl6p50wh"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m434.92 275.93-11.38 6.19a3.53 3.53 0 0 0-.3 1.37v36.39a.82.82 0 0 0 .21.6l-115-66.37a.7.7 0 0 1-.3-.65v-36.4a2.28 2.28 0 0 1 1-1.77l9.95-5.76a.66.66 0 0 1 .74-.05z",
    style: {
      fill: "#263238",
      transformOrigin: "371.533px 264.935px 0"
    },
    id: "elmirl7dokwl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.93 275.92-105.17-60.74-4.8-2.77-5.07-2.93a.66.66 0 0 0-.74.05l-9.95 5.76a2 2 0 0 0-.71.76l115.06 66.06z",
    style: {
      fill: "#37474f",
      opacity: 0.5,
      transformOrigin: "371.71px 245.75px 0"
    },
    className: "animable",
    id: "elezhrqcx5vka"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.54 282.12a3.68 3.68 0 0 0-.31 1.39v36.39c0 .65.46.91 1 .59l11-6.34v-37.56a.7.7 0 0 0-.3-.66z",
    style: {
      fill: "#37474f",
      transformOrigin: "429.232px 298.278px 0"
    },
    id: "elhlutqkvz9j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.36 320.39.39-.19 1.69-1a11.45 11.45 0 0 0 2.53-7.17v-30.75a9 9 0 0 0-.25-2l-.91.5a7.72 7.72 0 0 1 .16 1.48v30.77a13.32 13.32 0 0 1-3.61 8.36z",
    style: {
      fill: "#263238",
      transformOrigin: "426.665px 299.835px 0"
    },
    id: "ele7xjjog52c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.34 174.48c-3.88-3.14-10.94-7.21-15.28-9.71-7.3-4.23-34.59-20-46-26.59a11.29 11.29 0 0 0-10.22 0l-93 53.72a11.33 11.33 0 0 0-5.11 8.85V257a11.36 11.36 0 0 0 5.11 8.86L319.69 375a11.35 11.35 0 0 0 10.22 0l93-53.7a11.36 11.36 0 0 0 5.09-8.9v-31.7a10 10 0 0 0-3.94-8c-21.34-16.21-122.52-93.21-128.72-98.22z",
    style: {
      fill: "#455a64",
      transformOrigin: "276.865px 256.586px 0"
    },
    id: "elu8q58pd7hrf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428 312.4v-30.77a7.9 7.9 0 0 0-.22-1.84L324.54 339.3a9 9 0 0 1 .25 1.95V372c0 3-1.9 4.31-4.36 3.31h.07c.23.1.46.19.7.27l.46.14c.25.07.5.13.76.18s.34.06.51.09l.77.1h1.96l.66-.05c.24 0 .48-.08.72-.13l.56-.1c.26-.07.52-.16.77-.24s.3-.08.44-.14a7.53 7.53 0 0 0 .95-.45.61.61 0 0 0 .14-.07l93-53.7 1.34-.76a12.37 12.37 0 0 0 3.76-8.05z",
    style: {
      fill: "#37474f",
      transformOrigin: "374.215px 327.94px 0"
    },
    id: "elor7l9h9xr1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.12 234.09c17.44 14.08 108.52 83 128.7 98.26a10 10 0 0 1 4 8V372c0 3.25-2.3 4.58-5.11 3L130.79 265.9a11.36 11.36 0 0 1-5.11-8.86v-56.29c0-3.25 2.3-4.58 5.11-2.95l46 26.56c4.37 2.51 11.43 6.58 15.33 9.73z",
    style: {
      fill: "#263238",
      transformOrigin: "225.25px 286.384px 0"
    },
    id: "el9hrz7rqx4hq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.56 215.86c4.34 2.5 11.4 6.57 15.31 9.73a119.5 119.5 0 0 1 10.72 10 4.86 4.86 0 0 0 5.65.82l67.48-39a2.72 2.72 0 0 0 .64-4.45 120.36 120.36 0 0 0-10.75-10c-3.89-3.14-10.95-7.2-15.29-9.71-8.26-4.78-17.53-10.13-25.88-14.94a7 7 0 0 0-6.29 0l-67.45 38.98c-1.73 1-1.73 2.63 0 3.63z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "228.323px 197.266px 0"
    },
    id: "elalsjaxsj49v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.15 161.53a7 7 0 0 1 6.29 0c8.35 4.81 17.62 10.16 25.88 14.94 4.34 2.51 11.4 6.58 15.29 9.72a120.19 120.19 0 0 1 10.75 10 3.12 3.12 0 0 1 .33.41 3.22 3.22 0 0 1-1 .85l-67.48 39a4.86 4.86 0 0 1-5.65-.82 119.5 119.5 0 0 0-10.72-10c-3.91-3.16-11-7.23-15.31-9.73l-25.83-14.98c-.12-.07-.21-.15-.31-.22a2.44 2.44 0 0 1 .31-.22z",
    style: {
      fill: "#fff",
      transformOrigin: "228.54px 198.896px 0"
    },
    id: "eltb31sh85wgo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "227.49px 193.96px 0"
    },
    id: "elmn4gybtd1fn",
    className: "animable",
    d: "m234.26 212.95-20.19-.31v-8.06l14.46 2.62-.19-32.03 12.57-.2-6.65 37.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.73 213.82.67-2.78 2.8-.23 9.15-5.28c4.34-2.5 10.09-2 12.89 1.11a5.67 5.67 0 0 1 1.27 2.27l.79-.07-.71 2.95a8.18 8.18 0 0 1-4.05 4.9l-11.14 6.42a4.82 4.82 0 0 1-5.65-.81c-1.76-1.88-3.52-3.83-5.28-5.81a2.92 2.92 0 0 1-.74-2.67z",
    style: {
      fill: "#f04e30",
      transformOrigin: "306.479px 213.809px 0"
    },
    id: "elj84w245b14j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.73 213.82.67-2.78 2.8-.23 9.15-5.28c4.34-2.5 10.09-2 12.89 1.11a5.67 5.67 0 0 1 1.27 2.27l.79-.07-.71 2.95a8.18 8.18 0 0 1-4.05 4.9l-11.14 6.42a4.82 4.82 0 0 1-5.65-.81c-1.76-1.88-3.52-3.83-5.28-5.81a2.92 2.92 0 0 1-.74-2.67z",
    style: {
      opacity: 0.1,
      transformOrigin: "306.479px 213.809px 0"
    },
    className: "animable",
    id: "el7ndc21zssj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305 220.34 11.14-6.43c4.35-2.51 5.51-7 2.71-10.06s-8.55-3.61-12.89-1.11l-11.14 6.43a2.85 2.85 0 0 0-.75 4.54q2.64 3 5.29 5.81a4.81 4.81 0 0 0 5.64.82z",
    style: {
      fill: "#f04e30",
      transformOrigin: "306.813px 211.035px 0"
    },
    id: "ele8vjuh7b96",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.76 248.48.68-2.82.79-.07a9.75 9.75 0 0 1 2.7-2.25l11.14-6.43a4.65 4.65 0 0 1 5.56.9c1.73 1.95 3.46 3.87 5.19 5.73l1.57-.13-.71 2.93a2.94 2.94 0 0 1-1.4 1.72l-11.14 6.43c-4.35 2.51-10.22 2.11-13-1a5.48 5.48 0 0 1-1.38-5.01z",
    style: {
      fill: "#f04e30",
      transformOrigin: "249.506px 246.246px 0"
    },
    id: "elg0b8mv16u19",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.76 248.48.68-2.82.79-.07a9.75 9.75 0 0 1 2.7-2.25l11.14-6.43a4.65 4.65 0 0 1 5.56.9c1.73 1.95 3.46 3.87 5.19 5.73l1.57-.13-.71 2.93a2.94 2.94 0 0 1-1.4 1.72l-11.14 6.43c-4.35 2.51-10.22 2.11-13-1a5.48 5.48 0 0 1-1.38-5.01z",
    style: {
      opacity: 0.1,
      transformOrigin: "249.506px 246.246px 0"
    },
    className: "animable",
    id: "elv5dthxvm6qc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.77 251.69 11.14-6.43a2.73 2.73 0 0 0 .64-4.45 339.19 339.19 0 0 1-5.27-5.81 4.65 4.65 0 0 0-5.56-.91l-11.14 6.43c-4.34 2.51-5.65 7.09-2.84 10.18s8.69 3.49 13.03.99z",
    style: {
      fill: "#f04e30",
      transformOrigin: "249.841px 243.435px 0"
    },
    id: "el1ncuahljrff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.64 230.88.66-2.75 2.14-.14 13.33-7.7a5.82 5.82 0 0 1 6.95 1.13q2 2.28 4.05 4.47a3.91 3.91 0 0 1 .36.47l1.33-.08-.69 2.87a3.6 3.6 0 0 1-1.78 2.29l-14.29 8.24a6 6 0 0 1-7.05-1c-1.35-1.46-2.71-2.95-4.06-4.47a3.66 3.66 0 0 1-.95-3.33z",
    style: {
      fill: "#f04e30",
      transformOrigin: "278.008px 230.004px 0"
    },
    id: "elxv6wjhuxmze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.64 230.88.66-2.75 2.14-.14 13.33-7.7a5.82 5.82 0 0 1 6.95 1.13q2 2.28 4.05 4.47a3.91 3.91 0 0 1 .36.47l1.33-.08-.69 2.87a3.6 3.6 0 0 1-1.78 2.29l-14.29 8.24a6 6 0 0 1-7.05-1c-1.35-1.46-2.71-2.95-4.06-4.47a3.66 3.66 0 0 1-.95-3.33z",
    style: {
      opacity: 0.1,
      transformOrigin: "278.008px 230.004px 0"
    },
    className: "animable",
    id: "el1b0afrk6qd8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.22 231.42c1.35 1.52 2.71 3 4.06 4.47a6 6 0 0 0 7.05 1l14.29-8.24a3.42 3.42 0 0 0 .81-5.56c-1.35-1.46-2.7-3-4.05-4.48a5.81 5.81 0 0 0-6.95-1.12l-14.28 8.24a3.56 3.56 0 0 0-.93 5.69z",
    style: {
      fill: "#f04e30",
      transformOrigin: "278.351px 227.206px 0"
    },
    id: "elqhbcu48056",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75,
      transformOrigin: "278.313px 227.244px 0"
    },
    className: "animable",
    id: "elkgr85b70ndd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m305 220.34 11.14-6.43c4.35-2.51 5.51-7 2.71-10.06s-8.55-3.61-12.89-1.11l-11.14 6.43a2.85 2.85 0 0 0-.75 4.54q2.64 3 5.29 5.81a4.81 4.81 0 0 0 5.64.82z",
    style: {
      fill: "#fff",
      transformOrigin: "306.813px 211.035px 0"
    },
    id: "elyu0dtcmeq9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.77 251.69 11.14-6.43a2.73 2.73 0 0 0 .64-4.45 339.19 339.19 0 0 1-5.27-5.81 4.65 4.65 0 0 0-5.56-.91l-11.14 6.43c-4.34 2.51-5.65 7.09-2.84 10.18s8.69 3.49 13.03.99z",
    style: {
      fill: "#fff",
      transformOrigin: "249.841px 243.435px 0"
    },
    id: "elf7hdjyjkopq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.22 231.42c1.35 1.52 2.71 3 4.06 4.47a6 6 0 0 0 7.05 1l14.29-8.24a3.42 3.42 0 0 0 .81-5.56c-1.35-1.46-2.7-3-4.05-4.48a5.81 5.81 0 0 0-6.95-1.12l-14.28 8.24a3.56 3.56 0 0 0-.93 5.69z",
    style: {
      fill: "#fff",
      transformOrigin: "278.351px 227.206px 0"
    },
    id: "ellyl4paj583s",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m286.89 262.28-2.94.07-8.23-6.28a4.87 4.87 0 0 0-5-.32L258.14 263l-3.95.1v3.22a2.09 2.09 0 0 0 .92 1.62l10.24 7.82a4.89 4.89 0 0 0 5 .32l15.39-8.88a2 2 0 0 0 1.14-1.7z",
    style: {
      fill: "#f04e30",
      transformOrigin: "270.54px 265.913px 0"
    },
    id: "elhl5xxo8khgu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.89 262.28-2.94.07-8.23-6.28a4.87 4.87 0 0 0-5-.32L258.14 263l-3.95.1v3.22a2.09 2.09 0 0 0 .92 1.62l10.24 7.82a4.89 4.89 0 0 0 5 .32l15.39-8.88a2 2 0 0 0 1.14-1.7z",
    style: {
      opacity: 0.1,
      transformOrigin: "270.54px 265.913px 0"
    },
    className: "animable",
    id: "elggzyssxdpe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.33 261.4 15.4-8.87a4.87 4.87 0 0 1 5 .32l10.27 7.82a1.84 1.84 0 0 1-.22 3.31l-15.39 8.88a4.89 4.89 0 0 1-5-.32l-10.24-7.82a1.86 1.86 0 0 1 .18-3.32z",
    style: {
      fill: "#f04e30",
      transformOrigin: "270.574px 262.693px 0"
    },
    id: "elsy5wydzsq9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.33 261.4 15.4-8.87a4.87 4.87 0 0 1 5 .32l10.27 7.82a1.84 1.84 0 0 1-.22 3.31l-15.39 8.88a4.89 4.89 0 0 1-5-.32l-10.24-7.82a1.86 1.86 0 0 1 .18-3.32z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "270.574px 262.693px 0"
    },
    className: "animable",
    id: "eld0z6w4maktp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347 308.11-2.94.08-8.23-6.29a4.89 4.89 0 0 0-5-.32l-12.59 7.26-3.95.09v3.22a2.06 2.06 0 0 0 .92 1.62l10.24 7.82a4.87 4.87 0 0 0 5 .32L345.8 313a2 2 0 0 0 1.13-1.71z",
    style: {
      fill: "#f04e30",
      transformOrigin: "330.645px 311.747px 0"
    },
    id: "elkultvlvtfz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347 308.11-2.94.08-8.23-6.29a4.89 4.89 0 0 0-5-.32l-12.59 7.26-3.95.09v3.22a2.06 2.06 0 0 0 .92 1.62l10.24 7.82a4.87 4.87 0 0 0 5 .32L345.8 313a2 2 0 0 0 1.13-1.71z",
    style: {
      opacity: 0.1,
      transformOrigin: "330.645px 311.747px 0"
    },
    className: "animable",
    id: "elct32fgjz24d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.39 307.23 15.4-8.87a4.89 4.89 0 0 1 5 .32L346 306.5a1.85 1.85 0 0 1-.22 3.32l-15.4 8.87a4.87 4.87 0 0 1-5-.32l-10.24-7.82a1.86 1.86 0 0 1 .25-3.32z",
    style: {
      fill: "#f04e30",
      transformOrigin: "330.583px 308.527px 0"
    },
    id: "elhb9vzrh5fod",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.39 307.23 15.4-8.87a4.89 4.89 0 0 1 5 .32L346 306.5a1.85 1.85 0 0 1-.22 3.32l-15.4 8.87a4.87 4.87 0 0 1-5-.32l-10.24-7.82a1.86 1.86 0 0 1 .25-3.32z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "330.583px 308.527px 0"
    },
    className: "animable",
    id: "elcsu3lyuh7pf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.91 277.56-2.94.07-8.23-6.28a4.89 4.89 0 0 0-5-.33l-12.59 7.26-4 .1v3.22a2.11 2.11 0 0 0 .92 1.62l10.31 7.78a4.89 4.89 0 0 0 5 .33l15.39-8.88a2 2 0 0 0 1.14-1.7z",
    style: {
      fill: "#f04e30",
      transformOrigin: "290.53px 281.175px 0"
    },
    id: "elsle08rb0lgs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.91 277.56-2.94.07-8.23-6.28a4.89 4.89 0 0 0-5-.33l-12.59 7.26-4 .1v3.22a2.11 2.11 0 0 0 .92 1.62l10.31 7.78a4.89 4.89 0 0 0 5 .33l15.39-8.88a2 2 0 0 0 1.14-1.7z",
    style: {
      opacity: 0.1,
      transformOrigin: "290.53px 281.175px 0"
    },
    className: "animable",
    id: "elixbhooocg8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.35 276.68 15.4-8.88a4.89 4.89 0 0 1 5 .33l10.25 7.81a1.85 1.85 0 0 1-.22 3.32l-15.39 8.88a4.89 4.89 0 0 1-5-.33L275.14 280a1.86 1.86 0 0 1 .21-3.32z",
    style: {
      fill: "#f04e30",
      transformOrigin: "290.574px 277.97px 0"
    },
    id: "el0rthiyj2mq7i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.35 276.68 15.4-8.88a4.89 4.89 0 0 1 5 .33l10.25 7.81a1.85 1.85 0 0 1-.22 3.32l-15.39 8.88a4.89 4.89 0 0 1-5-.33L275.14 280a1.86 1.86 0 0 1 .21-3.32z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "290.574px 277.97px 0"
    },
    className: "animable",
    id: "elnjlj0vmj3l"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.93 292.83-2.94.08-8.23-6.29a4.89 4.89 0 0 0-5-.32l-12.59 7.26-3.95.1v3.22a2.06 2.06 0 0 0 .92 1.61l10.24 7.82a4.87 4.87 0 0 0 5 .32l15.39-8.87a2 2 0 0 0 1.13-1.71z",
    style: {
      fill: "#f04e30",
      transformOrigin: "310.575px 296.467px 0"
    },
    id: "el2mitgpkuc94",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.93 292.83-2.94.08-8.23-6.29a4.89 4.89 0 0 0-5-.32l-12.59 7.26-3.95.1v3.22a2.06 2.06 0 0 0 .92 1.61l10.24 7.82a4.87 4.87 0 0 0 5 .32l15.39-8.87a2 2 0 0 0 1.13-1.71z",
    style: {
      opacity: 0.1,
      transformOrigin: "310.575px 296.467px 0"
    },
    className: "animable",
    id: "elyy5g0zzxfw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.37 292 15.4-8.88a4.89 4.89 0 0 1 5 .32l10.23 7.78a1.85 1.85 0 0 1-.22 3.32l-15.39 8.87a4.87 4.87 0 0 1-5-.32l-10.24-7.82a1.85 1.85 0 0 1 .22-3.27z",
    style: {
      fill: "#f04e30",
      transformOrigin: "310.6px 293.267px 0"
    },
    id: "elhh2fghwkqmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.37 292 15.4-8.88a4.89 4.89 0 0 1 5 .32l10.23 7.78a1.85 1.85 0 0 1-.22 3.32l-15.39 8.87a4.87 4.87 0 0 1-5-.32l-10.24-7.82a1.85 1.85 0 0 1 .22-3.27z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "310.6px 293.267px 0"
    },
    className: "animable",
    id: "els18li67qeym"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.79 244.47-2.94.08-8.23-6.29a4.89 4.89 0 0 0-5-.32L289 245.2l-4 .1v3.22a2.09 2.09 0 0 0 .92 1.61l10.34 7.87a4.87 4.87 0 0 0 5 .32l15.4-8.87a2 2 0 0 0 1.13-1.71z",
    style: {
      fill: "#f04e30",
      transformOrigin: "301.395px 248.132px 0"
    },
    id: "el1x3ch956tiq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.79 244.47-2.94.08-8.23-6.29a4.89 4.89 0 0 0-5-.32L289 245.2l-4 .1v3.22a2.09 2.09 0 0 0 .92 1.61l10.34 7.87a4.87 4.87 0 0 0 5 .32l15.4-8.87a2 2 0 0 0 1.13-1.71z",
    style: {
      opacity: 0.1,
      transformOrigin: "301.395px 248.132px 0"
    },
    className: "animable",
    id: "elnwtr7fe8q6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.23 243.6 15.4-8.88a4.89 4.89 0 0 1 5 .32l10.24 7.82a1.86 1.86 0 0 1-.21 3.32l-15.4 8.87a4.87 4.87 0 0 1-5-.32L286 246.91a1.85 1.85 0 0 1 .23-3.31z",
    style: {
      fill: "#f04e30",
      transformOrigin: "301.438px 244.887px 0"
    },
    id: "el2xp5802f0b8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.23 243.6 15.4-8.88a4.89 4.89 0 0 1 5 .32l10.24 7.82a1.86 1.86 0 0 1-.21 3.32l-15.4 8.87a4.87 4.87 0 0 1-5-.32L286 246.91a1.85 1.85 0 0 1 .23-3.31z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "301.438px 244.887px 0"
    },
    className: "animable",
    id: "elylyw9ucbde"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.85 290.31-2.94.07-8.23-6.29a4.91 4.91 0 0 0-5-.32L349.1 291l-4 .1v3.22a2.09 2.09 0 0 0 .92 1.62l10.24 7.81a4.89 4.89 0 0 0 5 .33l15.39-8.88a2 2 0 0 0 1.13-1.71z",
    style: {
      fill: "#f04e30",
      transformOrigin: "361.475px 293.924px 0"
    },
    id: "el7zfg288usrg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.85 290.31-2.94.07-8.23-6.29a4.91 4.91 0 0 0-5-.32L349.1 291l-4 .1v3.22a2.09 2.09 0 0 0 .92 1.62l10.24 7.81a4.89 4.89 0 0 0 5 .33l15.39-8.88a2 2 0 0 0 1.13-1.71z",
    style: {
      opacity: 0.1,
      transformOrigin: "361.475px 293.924px 0"
    },
    className: "animable",
    id: "el98hzg3jwat8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.29 289.43 15.4-8.88a4.89 4.89 0 0 1 5 .33l10.24 7.81a1.85 1.85 0 0 1-.22 3.32l-15.39 8.88a4.89 4.89 0 0 1-5-.33l-10.24-7.81a1.86 1.86 0 0 1 .21-3.32z",
    style: {
      fill: "#f04e30",
      transformOrigin: "361.509px 290.72px 0"
    },
    id: "elxwn1onj43h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.29 289.43 15.4-8.88a4.89 4.89 0 0 1 5 .33l10.24 7.81a1.85 1.85 0 0 1-.22 3.32l-15.39 8.88a4.89 4.89 0 0 1-5-.33l-10.24-7.81a1.86 1.86 0 0 1 .21-3.32z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "361.509px 290.72px 0"
    },
    className: "animable",
    id: "elsxzs0v7erk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.81 259.75-2.94.08-8.23-6.29a4.87 4.87 0 0 0-5-.32l-12.59 7.25-3.95.1v3.22a2.09 2.09 0 0 0 .92 1.62l10.24 7.82a4.89 4.89 0 0 0 5 .32l15.4-8.87a2 2 0 0 0 1.14-1.68z",
    style: {
      fill: "#f04e30",
      transformOrigin: "321.455px 263.383px 0"
    },
    id: "elagxwesdv1x8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.81 259.75-2.94.08-8.23-6.29a4.87 4.87 0 0 0-5-.32l-12.59 7.25-3.95.1v3.22a2.09 2.09 0 0 0 .92 1.62l10.24 7.82a4.89 4.89 0 0 0 5 .32l15.4-8.87a2 2 0 0 0 1.14-1.68z",
    style: {
      opacity: 0.1,
      transformOrigin: "321.455px 263.383px 0"
    },
    className: "animable",
    id: "el1sapytnsxzb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.25 258.87 15.4-8.87a4.89 4.89 0 0 1 5 .32l10.24 7.82a1.86 1.86 0 0 1-.21 3.32l-15.4 8.87a4.89 4.89 0 0 1-5-.32L306 262.19a1.86 1.86 0 0 1 .25-3.32z",
    style: {
      fill: "#f04e30",
      transformOrigin: "321.453px 260.165px 0"
    },
    id: "elma9x804ac5a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.25 258.87 15.4-8.87a4.89 4.89 0 0 1 5 .32l10.24 7.82a1.86 1.86 0 0 1-.21 3.32l-15.4 8.87a4.89 4.89 0 0 1-5-.32L306 262.19a1.86 1.86 0 0 1 .25-3.32z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "321.453px 260.165px 0"
    },
    className: "animable",
    id: "elo0mnq4m0qj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.83 275-2.94.07-8.23-6.28a4.87 4.87 0 0 0-5-.32l-12.59 7.25-3.95.1v3.22a2.09 2.09 0 0 0 .92 1.62l10.24 7.82a4.91 4.91 0 0 0 5 .32l15.4-8.8a2 2 0 0 0 1.14-1.7z",
    style: {
      fill: "#f04e30",
      transformOrigin: "341.475px 278.632px 0"
    },
    id: "elqpp4h19nxu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.83 275-2.94.07-8.23-6.28a4.87 4.87 0 0 0-5-.32l-12.59 7.25-3.95.1v3.22a2.09 2.09 0 0 0 .92 1.62l10.24 7.82a4.91 4.91 0 0 0 5 .32l15.4-8.8a2 2 0 0 0 1.14-1.7z",
    style: {
      opacity: 0.1,
      transformOrigin: "341.475px 278.632px 0"
    },
    className: "animable",
    id: "elffnuk7shc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.27 274.15 15.4-8.87a4.87 4.87 0 0 1 5 .32l10.24 7.82a1.84 1.84 0 0 1-.22 3.31l-15.39 8.88a4.89 4.89 0 0 1-5-.32l-10.24-7.82a1.86 1.86 0 0 1 .21-3.32z",
    style: {
      fill: "#f04e30",
      transformOrigin: "341.49px 275.443px 0"
    },
    id: "elumg3cdv93q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.27 274.15 15.4-8.87a4.87 4.87 0 0 1 5 .32l10.24 7.82a1.84 1.84 0 0 1-.22 3.31l-15.39 8.88a4.89 4.89 0 0 1-5-.32l-10.24-7.82a1.86 1.86 0 0 1 .21-3.32z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "341.49px 275.443px 0"
    },
    className: "animable",
    id: "elmpkg626vax"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.68 226.66-2.94.07-8.23-6.28a4.87 4.87 0 0 0-5-.32l-12.59 7.25-3.95.1v3.22a2.09 2.09 0 0 0 .92 1.62l10.24 7.82a4.89 4.89 0 0 0 5 .32l15.39-8.88a2 2 0 0 0 1.14-1.7z",
    style: {
      fill: "#f04e30",
      transformOrigin: "332.325px 230.293px 0"
    },
    id: "el71v8gzn8e8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.68 226.66-2.94.07-8.23-6.28a4.87 4.87 0 0 0-5-.32l-12.59 7.25-3.95.1v3.22a2.09 2.09 0 0 0 .92 1.62l10.24 7.82a4.89 4.89 0 0 0 5 .32l15.39-8.88a2 2 0 0 0 1.14-1.7z",
    style: {
      opacity: 0.1,
      transformOrigin: "332.325px 230.293px 0"
    },
    className: "animable",
    id: "el5opoln1gwow"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.12 225.78 15.4-8.87a4.87 4.87 0 0 1 5 .32l10.24 7.82a1.84 1.84 0 0 1-.22 3.31l-15.39 8.88a4.89 4.89 0 0 1-5-.32l-10.24-7.82a1.86 1.86 0 0 1 .21-3.32z",
    style: {
      fill: "#f04e30",
      transformOrigin: "332.34px 227.073px 0"
    },
    id: "el1ff5t0dztb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.12 225.78 15.4-8.87a4.87 4.87 0 0 1 5 .32l10.24 7.82a1.84 1.84 0 0 1-.22 3.31l-15.39 8.88a4.89 4.89 0 0 1-5-.32l-10.24-7.82a1.86 1.86 0 0 1 .21-3.32z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "332.34px 227.073px 0"
    },
    className: "animable",
    id: "el3azc4pd8guc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.74 272.49-2.94.08-8.23-6.29a4.87 4.87 0 0 0-5-.32L380 273.21l-3.95.1v3.22a2.06 2.06 0 0 0 .92 1.62l10.24 7.85a4.87 4.87 0 0 0 5 .32l15.4-8.87a2 2 0 0 0 1.13-1.71z",
    style: {
      fill: "#f04e30",
      transformOrigin: "392.395px 276.14px 0"
    },
    id: "elrexzkxo96pa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.74 272.49-2.94.08-8.23-6.29a4.87 4.87 0 0 0-5-.32L380 273.21l-3.95.1v3.22a2.06 2.06 0 0 0 .92 1.62l10.24 7.85a4.87 4.87 0 0 0 5 .32l15.4-8.87a2 2 0 0 0 1.13-1.71z",
    style: {
      opacity: 0.1,
      transformOrigin: "392.395px 276.14px 0"
    },
    className: "animable",
    id: "el3pedqxo026b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.18 271.61 15.4-8.87a4.89 4.89 0 0 1 5 .32l10.24 7.82a1.85 1.85 0 0 1-.22 3.32l-15.4 8.87a4.87 4.87 0 0 1-5-.32l-10.2-7.82a1.86 1.86 0 0 1 .18-3.32z",
    style: {
      fill: "#f04e30",
      transformOrigin: "392.408px 272.907px 0"
    },
    id: "elneyqgy2weas",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.18 271.61 15.4-8.87a4.89 4.89 0 0 1 5 .32l10.24 7.82a1.85 1.85 0 0 1-.22 3.32l-15.4 8.87a4.87 4.87 0 0 1-5-.32l-10.2-7.82a1.86 1.86 0 0 1 .18-3.32z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "392.408px 272.907px 0"
    },
    className: "animable",
    id: "elts412fq4xl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.72 257.21-2.94.08-8.23-6.29a4.89 4.89 0 0 0-5-.32L360 257.94l-4 .1v3.22a2.06 2.06 0 0 0 .92 1.61l10.24 7.82a4.85 4.85 0 0 0 5 .32l15.4-8.87a2 2 0 0 0 1.13-1.71z",
    style: {
      fill: "#f04e30",
      transformOrigin: "372.36px 260.848px 0"
    },
    id: "elv79dfixqbvc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.72 257.21-2.94.08-8.23-6.29a4.89 4.89 0 0 0-5-.32L360 257.94l-4 .1v3.22a2.06 2.06 0 0 0 .92 1.61l10.24 7.82a4.85 4.85 0 0 0 5 .32l15.4-8.87a2 2 0 0 0 1.13-1.71z",
    style: {
      opacity: 0.1,
      transformOrigin: "372.36px 260.848px 0"
    },
    className: "animable",
    id: "elxt8xb6di08b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.16 256.34 15.4-8.88a4.89 4.89 0 0 1 5 .32l10.24 7.82a1.85 1.85 0 0 1-.22 3.32l-15.4 8.87a4.85 4.85 0 0 1-5-.32L357 259.65a1.85 1.85 0 0 1 .16-3.31z",
    style: {
      fill: "#f04e30",
      transformOrigin: "372.392px 257.628px 0"
    },
    id: "elsykpfjzehw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.16 256.34 15.4-8.88a4.89 4.89 0 0 1 5 .32l10.24 7.82a1.85 1.85 0 0 1-.22 3.32l-15.4 8.87a4.85 4.85 0 0 1-5-.32L357 259.65a1.85 1.85 0 0 1 .16-3.31z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "372.392px 257.628px 0"
    },
    className: "animable",
    id: "el8rd7ow43wme"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.7 241.94-2.94.07-8.23-6.28a4.89 4.89 0 0 0-5-.33L340 242.66l-3.95.1V246a2.08 2.08 0 0 0 .92 1.62l10.24 7.81a4.89 4.89 0 0 0 5 .33l15.39-8.88a2 2 0 0 0 1.13-1.7z",
    style: {
      fill: "#f04e30",
      transformOrigin: "352.39px 245.58px 0"
    },
    id: "el2xl0hruw97m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.7 241.94-2.94.07-8.23-6.28a4.89 4.89 0 0 0-5-.33L340 242.66l-3.95.1V246a2.08 2.08 0 0 0 .92 1.62l10.24 7.81a4.89 4.89 0 0 0 5 .33l15.39-8.88a2 2 0 0 0 1.13-1.7z",
    style: {
      opacity: 0.1,
      transformOrigin: "352.39px 245.58px 0"
    },
    className: "animable",
    id: "eldstr9veek2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.14 241.06 15.4-8.88a4.89 4.89 0 0 1 5 .33l10.24 7.81a1.85 1.85 0 0 1-.22 3.32l-15.39 8.88a4.89 4.89 0 0 1-5-.33l-10.24-7.81a1.86 1.86 0 0 1 .21-3.32z",
    style: {
      fill: "#f04e30",
      transformOrigin: "352.359px 242.35px 0"
    },
    id: "el0o7vx28woazd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.14 241.06 15.4-8.88a4.89 4.89 0 0 1 5 .33l10.24 7.81a1.85 1.85 0 0 1-.22 3.32l-15.39 8.88a4.89 4.89 0 0 1-5-.33l-10.24-7.81a1.86 1.86 0 0 1 .21-3.32z",
    style: {
      fill: "#fff",
      opacity: 0.75,
      transformOrigin: "352.359px 242.35px 0"
    },
    className: "animable",
    id: "eldq49xb8215g"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-25",
    style: {
      transformOrigin: "114.795px 229.278px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedLeft",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-25",
    style: {
      transformOrigin: "114.795px 229.278px 0"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.66 147.44v-11.09A10.39 10.39 0 0 0 110.27 126v11.09a10.39 10.39 0 0 0 10.39 10.35z",
    style: {
      fill: "#263238",
      transformOrigin: "115.465px 136.72px 0"
    },
    id: "el1j5ibiief36",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "139.355px 257.945px 0"
    },
    id: "elboqzamskkis",
    className: "animable",
    d: "m154.46 238.48-33.21-16.87 3 55.8 33.21 16.87-3-55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "139.355px 257.945px 0"
    },
    className: "animable",
    d: "m154.46 238.48-33.21-16.87 3 55.8 33.21 16.87-3-55.8z",
    id: "elslckjqllzl9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "163.765px 264.35px 0"
    },
    id: "el3q4351xw51s",
    className: "animable",
    d: "m157.46 294.28 15.61-10.16-12.36-49.7-6.25 4.06 3 55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "165.265px 288.8px 0"
    },
    id: "elecpkkr6yssv",
    className: "animable",
    d: "m173.07 284.12-10.6-.8-5.01 10.96 15.61-10.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      transformOrigin: "165.265px 288.8px 0"
    },
    className: "animable",
    d: "m173.07 284.12-10.6-.8-5.01 10.96 15.61-10.16z",
    id: "elta4fpsa4zb"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "158.365px 264.52px 0"
    },
    id: "el8ucavw9e9hs",
    className: "animable",
    d: "m162.47 283.32-8.21-48.56.2 3.72 3 55.8 5.01-10.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      transformOrigin: "158.365px 264.52px 0"
    },
    className: "animable",
    d: "m162.47 283.32-8.21-48.56.2 3.72 3 55.8 5.01-10.96z",
    id: "elkfawg1y8xl"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "140.98px 228.015px 0"
    },
    id: "elejbpx3pgcpn",
    className: "animable",
    d: "m121.25 221.61 6.44-.34-.2-3.72 33.22 16.87-6.45.34.2 3.72-33.21-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.93 236.54c0 .47-.3.69-.73.47a1.67 1.67 0 0 1-.82-1.26c0-.48.3-.69.73-.48a1.69 1.69 0 0 1 .82 1.27z",
    style: {
      fill: "#455a64",
      transformOrigin: "143.155px 236.142px 0"
    },
    id: "elmlrukql60j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 231.58c0 .48-.3.7-.73.48a1.7 1.7 0 0 1-.82-1.26c0-.48.3-.69.73-.48a1.66 1.66 0 0 1 .82 1.26z",
    style: {
      fill: "#455a64",
      transformOrigin: "133.225px 231.192px 0"
    },
    id: "el6n1zq07wtqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 232.59c0 .48-.3.69-.73.47a1.65 1.65 0 0 1-.82-1.26c0-.48.3-.69.73-.47a1.65 1.65 0 0 1 .82 1.26z",
    style: {
      fill: "#455a64",
      transformOrigin: "149.225px 232.195px 0"
    },
    id: "elw0u55jttmap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.13 227.58c0 .48-.3.69-.73.48a1.66 1.66 0 0 1-.82-1.27c0-.48.3-.69.73-.47a1.67 1.67 0 0 1 .82 1.26z",
    style: {
      fill: "#455a64",
      transformOrigin: "139.355px 227.187px 0"
    },
    id: "el9ih8zh22v6a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "163.665px 259.27px 0"
    },
    id: "ela22y060l8an",
    className: "animable",
    d: "m160.71 234.42-6.45.34 8.21 48.56 10.6.8-12.36-49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "163.665px 259.27px 0"
    },
    className: "animable",
    d: "m160.71 234.42-6.45.34 8.21 48.56 10.6.8-12.36-49.7z",
    id: "elmyn55q0wwb"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "128.535px 221.695px 0"
    },
    id: "el293vulscir4",
    className: "animable",
    d: "m127.49 217.55.2 3.72.2 3.72 1.69.85-2.09-8.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "128.535px 221.695px 0"
    },
    className: "animable",
    d: "m127.49 217.55.2 3.72.2 3.72 1.69.85-2.09-8.29z",
    id: "el9lvtpntrjwg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.56 135.1c4.48-.24 13.55.14 16.87 13 2.8 10.8 10.37 34.44 12.34 44.94 1.5 8 3.56 13.6 3.86 19.18-.56 2.87-2.85 6-9.15 7-6-1.59-4.95-2.58-5.37-7.9s2.32-6.84 1.45-13.15c-1.82-13.25-13.68-40.86-13.68-40.86z",
    style: {
      fill: "#b16668",
      transformOrigin: "129.095px 177.139px 0"
    },
    id: "elq78ujoqjkgp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.22 232.67a.48.48 0 0 1-.46-.37c0-.07-1.48-6.56-3.13-11.48-1.3-3.87-4.16-4.74-6.67-5.51-.56-.17-1.09-.33-1.57-.51a.49.49 0 0 1-.27-.62.48.48 0 0 1 .62-.28c.46.18 1 .33 1.5.5 2.6.79 5.84 1.78 7.3 6.12 1.66 5 3.14 11.5 3.15 11.57a.47.47 0 0 1-.36.57z",
    style: {
      fill: "#263238",
      transformOrigin: "143.397px 223.269px 0"
    },
    id: "elcg0kx5xlqog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.44 206.64a23.91 23.91 0 0 0-2.19 5.89c-.16 1.11-2 .24-2.37-1.2a47.49 47.49 0 0 1-.38-6.93s-.86 4.43-.39 6.54 1 2.53 2.54 3 1.3-.89 1.66-2.65 1.13-4.65 1.13-4.65z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "138.705px 209.217px 0"
    },
    id: "elhtifi8mkpoi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.59 235.89 141.9 223c-.14-2.84-.31-6.07-5.1-8.53-1.68-.86-2.92-1.11-3.51-.69s-.44 1.46-.44 1.47l.85 15.82a.48.48 0 0 1-.95 0l-.85-15.77a2.63 2.63 0 0 1 .83-2.34c.93-.67 2.41-.47 4.51.61 5.28 2.72 5.47 6.38 5.61 9.33l.7 12.87a.49.49 0 0 1-.46.51.48.48 0 0 1-.5-.39z",
    style: {
      fill: "#263238",
      transformOrigin: "137.71px 224.427px 0"
    },
    id: "elygavrumw5da",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.35 227.52a.48.48 0 0 1-.46-.37l-2.13-9.64a.48.48 0 0 1 .37-.57.49.49 0 0 1 .57.37l2.12 9.63a.47.47 0 0 1-.36.57z",
    style: {
      fill: "#263238",
      transformOrigin: "138.291px 222.226px 0"
    },
    id: "eleea3u0spawg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.12 214.15c-1.81-1.1-5.33-2.71-6.15-1.73s-1.87 5 2.21 6.42a11.73 11.73 0 0 0 8.17-.7z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "134.78px 215.693px 0"
    },
    id: "elhym3pdopqdr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 128.5h-3.91a20 20 0 0 1-20-20 21.35 21.35 0 0 1 21.35-21.35h1.25A21.35 21.35 0 0 1 126 108.48a20 20 0 0 1-20 20.02z",
    style: {
      fill: "#263238",
      transformOrigin: "104.045px 107.825px 0"
    },
    id: "eluxnxkdsa7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.86 92.77a2.88 2.88 0 0 1 2.26 3.38L81.48 95a2.88 2.88 0 0 1 3.38-2.23z",
    style: {
      fill: "#263238",
      transformOrigin: "84.3274px 94.432px 0"
    },
    id: "el0v08mnrsc1lf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.54 91.55a2.87 2.87 0 0 1-1.84 3.62l-1.78-5.47a2.87 2.87 0 0 1 3.62 1.85z",
    style: {
      fill: "#263238",
      transformOrigin: "86.8009px 92.3646px 0"
    },
    id: "elqfqc4a4ja8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75 355c-1.31-1-2.79-1.94-3.94-3-2.55-2.33-3.33-8.23-3.52-10.22a24.36 24.36 0 0 1-.05-5.1c.51-4 3.45-12.79 3.45-12.79s-9.47-6.23-9.61-6.15-1.71 11.45-3.26 13.31c-1.88 1.65-3.49 2.11-4.55 4.29-.93 2.69-.55 4.14.88 6.94a35.79 35.79 0 0 1 2.34 7.56c.81 3.28.47 8.65 8.62 10.29 4.32.87 7.31.29 9.37-.63 2.32-1.03 2.3-2.97.27-4.5z",
    style: {
      fill: "#b16668",
      transformOrigin: "106.505px 339.149px 0"
    },
    id: "el8vvmq1thu1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.27 335.35c-.93 2.69-.55 4.14.88 6.94a35.79 35.79 0 0 1 2.34 7.56c.81 3.28.47 8.65 8.62 10.29 4.32.87 7.31.29 9.37-.63 2.32-1 2.3-3 .27-4.51-1-.78-2.16-1.53-3.15-2.33 1.08 1.94-4.11 2.4-7.1.61s-6.72-14.4-7.09-17.22a11.77 11.77 0 0 1 .41-5c.11-.15.25-.37.25-.37s-.32-.13-.66.13a12.79 12.79 0 0 0-4.14 4.53z",
    style: {
      fill: "#263238",
      transformOrigin: "106.505px 345.613px 0"
    },
    id: "elakunzvm5295",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.74 191.18c1.46 16 5.88 70.88 4.69 81.22-.53 4.69-20.41 56.89-20.41 56.89s-4.85 1.49-9.42-3.69c2.36-22.44 4.62-46.48 9.52-53.93-.93-7.72-10.56-46.18-10.56-46.18z",
    style: {
      fill: "#37474f",
      transformOrigin: "116.096px 260.334px 0"
    },
    id: "eluapqmxkfqk8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.87 347.16v-1.41c.56 1.65 3.15 8.79 7.07 12.36 3.11 2.85 7.36 6.13 8.44 9.3s-5.91 4.4-8.82 3.88c-3.39-.59-7.76-2.51-10.14-5.44-1.68-2.06-2.75-4.5-3.94-6.12s-4-3.42-4.6-5.29c-.36-1 .07-3.29.56-5.19s1-3.67 1.56-3.5v1.07c.71.8 2.7 1.59 4.93 1.67 1.45.06 4.96-.23 4.94-1.33z",
    style: {
      fill: "#263238",
      transformOrigin: "92.6195px 358.572px 0"
    },
    id: "el0gxjc7vyvlkk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.76 360.61c-1-.86-1.94-1.7-2.82-2.51-2.74-2.49-4.83-6.73-6-9.62a13.63 13.63 0 0 1-1-5.2v-5.63H81v9.4c.47 2.05 5 7.51 7.58 11.07 1.73 2.39 5 5.42 8.93 5.95 3.76.53 5.66-.64 3.25-3.46z",
    style: {
      fill: "#b16668",
      transformOrigin: "91.4159px 350.922px 0"
    },
    id: "eln1diwj1tr2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 193.63c-7.66 16.73.28 75.65.28 75.65-.23 2.72-3.34 8.06-4.49 20-1.37 14.11 2.14 49.56 2.14 49.56a10.67 10.67 0 0 0 10 .39s9.42-53.38 11.19-67.41c1.54-12.25 5.78-49.93 5.78-49.93l18.9-30.72z",
    style: {
      fill: "#37474f",
      transformOrigin: "102.636px 265.729px 0"
    },
    id: "elg2qjfap7sa8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.29 135.3-10.29.49c-1.41.44-5.2 4-6.69 9.45a24.16 24.16 0 0 0 .69 13.54l6.84 19.79s-3.2 7.75-6.92 15.06c17.17 9.59 38.61 4.55 43.78-2.45.21-1.48-.08-8.17.33-15.77.45-8.12 1.56-17.28.29-22.29-2.37-9.31-6.81-18.05-15.64-18.05z",
    style: {
      fill: "#f04e30",
      transformOrigin: "104.782px 166.999px 0"
    },
    id: "elwd4509f8rg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.76 96c2.32 1.37 5.19 7.21 4.91 19.45-.24 10.37-3.61 12.93-5.29 13.67s-4.95.29-8.11-.24v6.23s4.37 5.08 4.1 7.93-6.32 3.53-10.41.74a26.27 26.27 0 0 1-6.72-7V123a6.27 6.27 0 0 1-5.63-.72C88.09 120 88 114.19 90 112.13s6.41-1.41 7.23 1.44c0 0 5.05.18 11.77-3.51A18.9 18.9 0 0 0 118.76 96z",
    style: {
      fill: "#b16668",
      transformOrigin: "106.187px 120.779px 0"
    },
    id: "el29pczmyj9g7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.53 113a1.31 1.31 0 1 1-1.37-1.29 1.33 1.33 0 0 1 1.37 1.29z",
    style: {
      fill: "#263238",
      transformOrigin: "111.22px 113.019px 0"
    },
    id: "elsdw4km2uf7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.43 121.66 3 1a1.56 1.56 0 0 1-2 1.09 1.67 1.67 0 0 1-1-2.09z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "113.887px 122.744px 0"
    },
    id: "eld3dpk5wteha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.78 108.86-2.64-1.86a1.54 1.54 0 0 1 2.19-.45 1.69 1.69 0 0 1 .45 2.31z",
    style: {
      fill: "#263238",
      transformOrigin: "121.597px 107.566px 0"
    },
    id: "elncwt7hb1pka",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.4 112.78a1.31 1.31 0 1 1-1.37-1.29 1.34 1.34 0 0 1 1.37 1.29z",
    style: {
      fill: "#263238",
      transformOrigin: "121.09px 112.799px 0"
    },
    id: "el5h8qfb5z16m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a4a4d",
      transformOrigin: "118.19px 115.1px 0"
    },
    id: "elvf9fep20x4j",
    className: "animable",
    d: "m116.02 111.17.21 7.86 4.13-1.28-4.34-6.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.27 128.9c-3.34-.43-10.2-2.41-11.27-5.12a7 7 0 0 0 2.41 3.46c2 1.76 8.86 3.74 8.86 3.74z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "104.635px 127.38px 0"
    },
    id: "el5qwz2hs9tzg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.19 257.26-2.94-12.58 2.59-22.78s8.15-3.07 12.47-9.38a25.87 25.87 0 0 1-9.25 11.36l-4.44 20.74z",
    style: {
      fill: "#263238",
      transformOrigin: "112.78px 234.89px 0"
    },
    id: "el7tvy4vbir3r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "78.9px 252.55px 0"
    },
    id: "el65vw7ms6jpj",
    className: "animable",
    d: "M100.35 232.77 64.6 212.13l-7.15 60.2 35.75 20.64 7.15-60.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "78.9px 252.55px 0"
    },
    className: "animable",
    d: "M100.35 232.77 64.6 212.13l-7.15 60.2 35.75 20.64 7.15-60.2z",
    id: "elb04ab1klbjo"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "102.135px 286.775px 0"
    },
    id: "el94fwnfz53b",
    className: "animable",
    d: "m111.07 282.65-10.72-2.07-7.15 12.39 17.87-10.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      transformOrigin: "102.135px 286.775px 0"
    },
    className: "animable",
    d: "m111.07 282.65-10.72-2.07-7.15 12.39 17.87-10.32z",
    id: "elifkpl9mcp6i"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "98.56px 259.775px 0"
    },
    id: "elk4ithisov",
    className: "animable",
    d: "m100.35 280.58 3.57-54-3.57 6.19-7.15 60.2 7.15-12.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      transformOrigin: "98.56px 259.775px 0"
    },
    className: "animable",
    d: "m100.35 280.58 3.57-54-3.57 6.19-7.15 60.2 7.15-12.39z",
    id: "elx61qaru0pl"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "87.835px 219.355px 0"
    },
    id: "el4pawbs8hph9",
    className: "animable",
    d: "m64.6 212.13 10.72-2.06v-4.13l35.75 20.64h-7.15l-3.57 6.19-35.75-20.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.22 232.18c0 .53-.38.74-.84.48a1.86 1.86 0 0 1-.83-1.45c0-.53.37-.75.83-.48a1.85 1.85 0 0 1 .84 1.45z",
    style: {
      fill: "#455a64",
      transformOrigin: "86.385px 231.693px 0"
    },
    id: "eltwgah6j5pfo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.74 225.52c0 .54-.37.75-.84.49a1.86 1.86 0 0 1-.83-1.45c0-.53.37-.75.83-.48a1.81 1.81 0 0 1 .84 1.44z",
    style: {
      fill: "#455a64",
      transformOrigin: "75.905px 225.043px 0"
    },
    id: "elhko43jd6r4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.32 225c0 .53-.37.75-.83.48a1.84 1.84 0 0 1-.84-1.44c0-.54.38-.75.84-.49a1.86 1.86 0 0 1 .83 1.45z",
    style: {
      fill: "#455a64",
      transformOrigin: "97.485px 224.517px 0"
    },
    id: "elnqkulu4vjx8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.72 219.08c0 .53-.38.75-.84.48a1.83 1.83 0 0 1-.83-1.44c0-.53.37-.75.83-.48a1.84 1.84 0 0 1 .84 1.44z",
    style: {
      fill: "#455a64",
      transformOrigin: "86.885px 218.6px 0"
    },
    id: "elkndf7kslv3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "105.71px 254.615px 0"
    },
    id: "elojzvcvape7",
    className: "animable",
    d: "M111.07 226.58h-7.15l-3.57 54 10.72 2.07v-56.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f04e30",
      transformOrigin: "69.96px 214.195px 0"
    },
    id: "elgjyq6t25uv5",
    className: "animable",
    d: "M75.32 210.07v8.25l-10.72-6.19 10.72-2.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "105.71px 254.615px 0"
    },
    className: "animable",
    d: "M111.07 226.58h-7.15l-3.57 54 10.72 2.07v-56.07z",
    id: "elso1lavfloka"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "69.96px 214.195px 0"
    },
    className: "animable",
    d: "M75.32 210.07v8.25l-10.72-6.19 10.72-2.06z",
    id: "elkm69bwbs45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9 225.36a.43.43 0 0 1-.19 0 .52.52 0 0 1-.27-.66l9.1-21.53a.51.51 0 0 1 .66-.27.52.52 0 0 1 .27.66l-9.1 21.53a.52.52 0 0 1-.47.27z",
    style: {
      fill: "#263238",
      transformOrigin: "80.455px 214.117px 0"
    },
    id: "elztyamephvg7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.88 219a.5.5 0 0 1-.5-.5v-14.9a.5.5 0 0 1 1 0v14.91a.5.5 0 0 1-.5.49z",
    style: {
      fill: "#263238",
      transformOrigin: "86.88px 211.05px 0"
    },
    id: "el2h06xcq6rux",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70 180.48 13.87-19.41a20.4 20.4 0 0 0 4.86-7.93c2.42-7.67 2.8-12.17.26-17.35-5.64 0-8.94.57-15.35 11.42-5.23 8.85-13 23.94-14.9 27.2-2.37 4-3.06 5.11-1 9.07s9.82 14.13 16.35 21.78 10.35 10.23 15.23 11.36 7.06.18 9.81-2.35.81-4.78-1.75-5.37a21 21 0 0 1-6.84-2.81c-1.55-1.12-2-2-.59-2.06 1.86-.08 3.6-.45 4.08-1.75.6-1.63-.94-1.19-3.07-1.85a40.86 40.86 0 0 0-8.45-1.62C79 199 70 180.48 70 180.48",
    style: {
      fill: "#b16668",
      transformOrigin: "78.494px 176.44px 0"
    },
    id: "eldryozdnerqi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.87 125.85h1.37v13a9.49 9.49 0 0 1-9.49 9.49h-1.37v-13a9.49 9.49 0 0 1 9.49-9.49z",
    style: {
      fill: "#263238",
      transformOrigin: "91.81px 137.095px 0"
    },
    id: "ely1l062hkotp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 224.38v-11.29c0-1.65-.49-4.28-1.84-4.77a.5.5 0 1 1 .34-.94c2.43.89 2.5 5.22 2.5 5.71v11.29a.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5z",
    style: {
      fill: "#263238",
      transformOrigin: "96.4084px 216.113px 0"
    },
    id: "el42j0oo7x6ep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.51 232.13a.63.63 0 0 1-.19 0 .5.5 0 0 1-.27-.66c0-.06 2.45-5.82 5.34-14.08 2.81-8 1.82-9.6 1.26-9.9a.5.5 0 0 1-.2-.68.51.51 0 0 1 .68-.2c1.77 1 1.52 4.49-.79 11.11C89.44 226 87 231.77 87 231.83a.49.49 0 0 1-.49.3z",
    style: {
      fill: "#263238",
      transformOrigin: "90.1497px 219.344px 0"
    },
    id: "elntxikcx6ad",
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.07 232.91v16.37c0 1.23-.86 1.72-1.92 1.11L425.76 238a4.24 4.24 0 0 1-1.92-3.32v-16.34c0-1.22.86-1.72 1.92-1.11l21.39 12.35a4.24 4.24 0 0 1 1.92 3.33z",
    style: {
      fill: "#455a64"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardpay);
export default __webpack_public_path__ + "static/media/cardpay.2f66f0113cf5a264a00c0cdc345f3fd1.svg";
export { ForwardRef as ReactComponent };